import type { FormErrors } from 'redux-form';

class RateUpdateFM {
	updateShippingMarkup: boolean;
	shippingMarkup: Nullable<number>;
	updateSalesMarkup: boolean;
	salesMarkup: Nullable<number>;
	updateTax: boolean;
	tax: Nullable<number>;

	constructor() {
		this.updateShippingMarkup = false;
		this.shippingMarkup = null;
		this.updateSalesMarkup = false;
		this.salesMarkup = null;
		this.updateTax = false;
		this.tax = null;
	}

	static field(key: keyof RateUpdateFM) {
		return key;
	}

	static validate(form: RateUpdateFM) {
		const errors: FormErrors<RateUpdateFM> = {};

		const { updateSalesMarkup, updateShippingMarkup, updateTax } = form;

		if (!updateSalesMarkup && !updateShippingMarkup && !updateTax) {
			errors.shippingMarkup = 'At least one update must be applied.';
		}

		return errors;
	}
}

export default RateUpdateFM;
